const logo = document.querySelector(".js-logo-animation");
const logoAnimation = {

  init: function(){
    if (logo === null || !!sessionStorage.getItem("hideLogoAnimation") || window.matchMedia('(max-width: 991px)').matches) return;
    logo.classList.remove("logo-animation--hidden");
    
    setTimeout(() => {
      sessionStorage.setItem("hideLogoAnimation", "1");
      logo.classList.add("logo-animation--hidden");
    }, 6000);
  }
}

export default logoAnimation;